import { render } from "./CorrugationVideo.vue?vue&type=template&id=677232cc&scoped=true"
import script from "./CorrugationVideo.vue?vue&type=script&lang=js"
export * from "./CorrugationVideo.vue?vue&type=script&lang=js"

import "./CorrugationVideo.vue?vue&type=style&index=0&id=677232cc&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677232cc"]])

export default __exports__